<script>
import { BAvatar } from "bootstrap-vue";

export default {
  extends: BAvatar
};
</script>